import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';
import { CreativeIcon } from 'components/Atoms/Icon';
import { USER_LEVEL_TYPE } from 'constants/common';
import { t } from 'utilities/lang';

export const Creatives = lazy(() =>
  import('components/Pages/Library/components/Creatives')
);

const CreateCreative = lazy(() =>
  import(
    'components/Pages/Library/components/Creatives/components/CreateCreative'
  )
);
const EditCreative = lazy(() =>
  import(
    'components/Pages/Library/components/Creatives/components/EditCreative'
  )
);

const AdDetails = lazy(() => import('components/Pages/AdDetails'));

export const creativeRoutes = [
  {
    path: routePath.CREATIVES,
    component: Creatives,
    exact: true,
    showMenu: true,
    name: `${t('route.my')} ${routeName.CREATIVES}`,
    breadcrumbs: [{ name: routeName.LIBRARY }, { name: routeName.CREATIVES }],
    icon: CreativeIcon,
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.CREATE_CREATIVE,
    component: CreateCreative,
    exact: true,
    parentName: routeName.CREATIVES,
    breadcrumbs: [
      { name: routeName.LIBRARY },
      { name: routeName.CREATIVES, link: routePath.CREATIVES },
      { name: t('route.create_creative') },
    ],
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.CREATIVES_DETAIL,
    component: EditCreative,
    exact: true,
    parentName: routeName.EDIT_CREATIVES,
    breadcrumbs: [
      { name: routeName.LIBRARY },
      { name: routeName.CREATIVES, link: routePath.CREATIVES },
      { name: t('route.edit_creative') },
    ],
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.AD_DETAILS,
    component: AdDetails,
    exact: true,
    parentName: routeName.CREATIVES,
    breadcrumbs: [
      { name: routeName.LIBRARY },
      { name: routeName.CREATIVES, link: routePath.CREATIVES },
    ],
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
];
